import type { CitThemeId } from '@cloudintellitech/ui'
import {
  CIT_THEME_DEFINITIONS,
  CIT_THEME_IDS,
  DEFAULT_CIT_THEME_ID,
  isCitThemeId,
} from '@cloudintellitech/ui'

export type ThemePreference = CitThemeId

export const SIDEBAR_MODE_PREFERENCES = ['expanded', 'collapsed', 'auto'] as const
export type SidebarModePreference = typeof SIDEBAR_MODE_PREFERENCES[number]
export const DEFAULT_SIDEBAR_MODE_PREFERENCE: SidebarModePreference = 'expanded'
export const SIDEBAR_MODE_LABELS: Record<SidebarModePreference, string> = {
  expanded: '常驻展开',
  collapsed: '手动收起',
  auto: '自动收起',
}

export function isSidebarModePreference(value: unknown): value is SidebarModePreference {
  return (SIDEBAR_MODE_PREFERENCES as readonly unknown[]).includes(value)
}

export const DEFAULT_THEME_PREFERENCE: ThemePreference = DEFAULT_CIT_THEME_ID
export const THEME_PREFERENCES: readonly ThemePreference[] = CIT_THEME_IDS
export const THEME_PREFERENCE_LABELS = Object.fromEntries(
  CIT_THEME_DEFINITIONS.map(theme => [theme.id, theme.name]),
) as Record<ThemePreference, string>

export function isThemePreference(value: unknown): value is ThemePreference {
  return isCitThemeId(value)
}
